import React from 'react';
import merge from 'classnames';

import { useAuth } from '@/hooks/useAuth/useAuth';

import styles from './AssistingBanner.module.scss';

export const AssistingBanner = () => {
  const { userInfo } = useAuth();

  if (!userInfo?.isAssistedByAdmin) return null;

  const {
    assistingAdminName,
    firstName,
    lastName,
    companyInfo: { name: companyName },
  } = userInfo;

  return (
    <div className={styles.container} id={AssistingBanner.containerId}>
      {merge(assistingAdminName, 'assisting', firstName, lastName, {
        [`at ${companyName}`]: companyName,
      })}
    </div>
  );
};

AssistingBanner.containerId = 'assisting-banner-container';
